import { Aeroporto } from '../model';

export class CidadesWebServices {
  Id: number;
  Cidade?: any = {Nome : ''};
  CidadeId: number;
  IdCidadeFornecedor: string;
  WebService?: any = {Descricao : ''};
  WebServiceId: number;
  Ativo = true;
}

export class Cidade {
    Nome = '';
    Estado: Estado = new Estado();
    IdErp?: any;
    CodigoIbge: number;
    MostraOpcaoBusca: boolean;
    CidadeVinculadaId?: any;
    EstadoId: number;
    CidadeVinculada?: any = {Nome : ''};
    CidadesVinculadas?: any;
    CidadesWebServices?: CidadesWebServices[];
    Aeroportos?: Aeroporto[];
    Bairros?: any;
    Id: number;
    Erros?: any;
    display_field: string;
    Imagem: string;
    ImagemApresentacao: any;
    Alteracoes: any;
}

export class Estado {
  Id: number;
  Cidades: Cidade[];
  Nome: string;
  Pais?: Pais = new Pais();
  Iata: string = "";
}

export class Pais {
  Id: number;
  Estados: Estado[];
  Nome: string = "";
  Iata: string = "";
}
